import { render, staticRenderFns } from "./addRecommendation.vue?vue&type=template&id=71fc66bc"
import script from "./addRecommendation.vue?vue&type=script&lang=js"
export * from "./addRecommendation.vue?vue&type=script&lang=js"
import style0 from "./addRecommendation.vue?vue&type=style&index=0&id=71fc66bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports